export function isMobileViewHook(setIsMobile, width) {
  window.addEventListener('load', () => {
    getWidthAndDecideScreen(setIsMobile, width);
  });
  window.addEventListener('resize', () => {
    getWidthAndDecideScreen(setIsMobile, width);
  });
  getWidthAndDecideScreen(setIsMobile, width);
}

function getWidthAndDecideScreen(setIsMobile, width = 992) {
  if (window.screen.width < width || window.innerWidth < width) {
    setIsMobile(true);
  } else {
    setIsMobile(false);
  }
}

export function getWindowWidth(setIsMobile) {
  window.addEventListener('load', () => {
    getCurrentWidth(setIsMobile);
  });
  window.addEventListener('resize', () => {
    getCurrentWidth(setIsMobile);
  });
  getCurrentWidth(setIsMobile);
}

function getCurrentWidth(setIsMobile) {
  setIsMobile(window.screen.width || window.innerWidth);
}
